module.exports = __webpack_public_path__ + "static/media/haimian-zhaoshangzijinzhiguyuan.af53fae7.png";